import { render } from "./BindPhoneDialog.vue?vue&type=template&id=df42df58&scoped=true"
import script from "./BindPhoneDialog.vue?vue&type=script&lang=js"
export * from "./BindPhoneDialog.vue?vue&type=script&lang=js"

import "./BindPhoneDialog.vue?vue&type=style&index=0&id=df42df58&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df42df58"]])

export default __exports__